import { getParseStorage, getStorage, hasStorage } from "../store/localStorage";

const userInitialState = {
  userList: [],
  userListLoading: false,
  userDetails: {},
  userDetailsLoading: false,
  deleteUserLoading: false,
  sidebarShow: true,
  totalUsers: 0,
  userStatisticsData: [],
  userStatisticsLoading: false,
  displaySessionAlert: false,
  getFeedsLoading: false,
  allPosts: [],
  postsToReview: [],
  reportedPosts: [],
  getUserFeeds: [],
  getUserFeedsLoading: false,
  reportedPostLoading: false,
  premiumLoading: false,
  expiryLoading: false,
  tarrifArr: [],
  activePaymentTypes: [],
  paymentTypes: [],
  bulkReportedPostLoading: false,
  allAdmin: [],
  adminListLoading: false,
  totalAdminUsers: 0,
  deleteAdminLoading: false,
  isExistingUserName: false,
  isCheckExistingUserLoading: false,
  createUser: {},
  createUserLoading: false
};

const agentInitialState = {
  agentList: [],
  agentListLoading: false,
  totalAgents: 0,
  agentDetails: {},
  agentDetailsLoading: false,
  deleteAgentLoading: false,
  addAgentListLoading: false,
  personaTypes: []
}

const groupInitialState = {
  allGroupsList: [],
  groupListLoading: false,
  updateGroupListLoading: false,
  deleteGroupLoading: false,
  groupDetails: {},
  totalGroups: 0,
  removeUserLoading: false,
  feedLimit: 10,
  groupFeedsLoading: false,
  editGroupLoading: false,
  hashTagData: [],
  makeUserAdminLoading: false
};

let sessionInitialState = {
  isLoginLoading: false,
  sessionData: {},
  isAuthenticating: false,
  sidebarShow: true,
  sidebarUnfoldable: false,
  theme: 'light',
};

export const influencersInitialState = {
  isInfluencerSignupLoading: false,
  influencerSignupError: null,
  influencersListLoading: false,
  influencersListError: null,
  influencersList: [],
  totalRecords: 0,
  influencersCreateLoading: false,
  influencersUpdateLoading: false,
  influencersDeleteLoading: false,
  isExistingInfluencerName: false,
  isCheckExistingInfluencerLoading: false,
  promoCodeList: [],
  createListLoading: false,
  createPromoLoading: false,
  influencerReviewLoading: false,
  influencersPayLoading: false,
}

const premiumInitialState = {
  premiumUserList: [],
  premiumUserListLoading: false,
  totalRecords: 0,
}

const reportInitialState = {
  reportList: [],
  reportListLoading: false,
  totalRecords: 0,
}

if (hasStorage('userInfo')) {
  sessionInitialState = {
    ...sessionInitialState,
    sessionData: getStorage('userInfo'),
    isAuthenticating: getStorage('isAuthenticating'),
    theme: getParseStorage('coreui-free-react-admin-template-theme') || 'light'
  };
}

const initialState = {
  user: userInitialState,
  group: groupInitialState,
  session: sessionInitialState,
  premium: premiumInitialState,
  influencers: influencersInitialState,
  report: reportInitialState,
  agent: agentInitialState
};

export default initialState;